module.exports = __webpack_public_path__ + "static/workingplace-060a7e07c3d03169fc01048d5beb8092.png";